/**
 * WP-V2-IO — hook dev: ?interact=1 uruchamia InteractDemoScene.
 *
 * Side-effect import z main (jak WC `installWorldDev`):
 *   import './interact/installInteractDev.js';
 */
import type Phaser from 'phaser';
import { InteractDemoScene } from './InteractDemoScene.js';

export function isInteractDevQuery(
  search = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  try {
    return new URLSearchParams(search).get('interact') === '1';
  } catch {
    return false;
  }
}

/**
 * Rejestruje i startuje InteractDemo (zatrzymuje inne aktywne sceny).
 * @returns true gdy hook zadziałał.
 */
export function installInteractDevHook(game: Phaser.Game): boolean {
  if (!isInteractDevQuery()) return false;

  const key = InteractDemoScene.KEY;
  if (!game.scene.getScene(key)) {
    game.scene.add(key, InteractDemoScene, false);
  }

  for (const s of game.scene.getScenes(true)) {
    const sk = s.scene.key;
    if (sk !== key) {
      try {
        game.scene.stop(sk);
      } catch {
        /* ignore */
      }
    }
  }

  game.scene.start(key);
  return true;
}

/**
 * Czeka na window.__pieskowo i podmienia scenę gdy ?interact=1.
 */
export function autoAttachInteractDev(timeoutMs = 12_000): void {
  if (typeof window === 'undefined') return;
  if (!isInteractDevQuery()) return;

  const w = window as unknown as {
    __pieskowo?: Phaser.Game;
    __interactDevInstalled?: boolean;
    __pieskowoInteract?: { install: (g: Phaser.Game) => boolean };
  };

  w.__pieskowoInteract = { install: installInteractDevHook };

  if (w.__interactDevInstalled) return;

  const started = Date.now();
  const tick = (): void => {
    if (w.__interactDevInstalled) return;
    const game = w.__pieskowo;
    if (game) {
      window.setTimeout(() => {
        if (w.__interactDevInstalled) return;
        if (installInteractDevHook(game)) {
          w.__interactDevInstalled = true;
        }
      }, 80);
      return;
    }
    if (Date.now() - started < timeoutMs) {
      window.setTimeout(tick, 50);
    }
  };
  tick();
}

/**
 * Alias kompatybilny z wcześniejszym API (main może wołać tryAutoInstallInteractDev(game)).
 */
export function tryAutoInstallInteractDev(game?: Phaser.Game): boolean {
  if (game) return installInteractDevHook(game);
  autoAttachInteractDev();
  return isInteractDevQuery();
}

// Side-effect: w przeglądarce z ?interact=1 sam się podłączy po załadowaniu modułu.
autoAttachInteractDev();
